import React from 'react';

import * as S from './styles';

const Header: React.FC = () => {
  return (
    <S.Container>
      <S.Content className="left">
        <S.Wrapper
          className="wow animate__animated animate__fadeIn"
          data-wow-duration="1s"
        >
          <S.Title>
            Siga
            <br />a risca
          </S.Title>
          <S.Text>
            O momento pede um olhar delineado, gráfico, nítido, em contraste com
            uma pele clean e iluminada.
          </S.Text>
          <S.Credits>
            FOTOS: ARVED COLVIN-SMITH
            <br />
            BELEZA: JAMES MOLLOY <span>(Maquiagem) e </span>PAUL JONES{' '}
            <span>(Cabelo)</span>
            <br />
            EDIÇÃO DE MODA: GEORGIA MEDLEY
          </S.Credits>
        </S.Wrapper>
      </S.Content>
      <S.Content
        className="wow animate__animated animate__fadeIn"
        data-wow-duration="1s"
        data-wow-delay="400ms"
      >
        <S.Photo />
        <S.Legend>Brinco, Bea Bongiasca.</S.Legend>
      </S.Content>
    </S.Container>
  );
};

export default Header;
